import { IStagedBetsStore } from './interfaces';

export const stagedBetsSelectors = {
    getActiveChipsGameIds: (state: IStagedBetsStore) =>
        Object.keys(state)
            .filter((key) => state[key].length > 0)
            .map(Number),
};
